export interface VerenaConfig {
  /** Required — identifies the site */
  siteKey: string;
  /** API base URL (defaults to Verena's hosted service) */
  apiUrl?: string;
  /** Widget theme */
  theme?: 'light' | 'dark' | 'auto';
  /** Callback when user is verified */
  onVerified?: (proof: VerenaProof) => void;
  /** Callback on failure */
  onError?: (error: Error) => void;
}

export interface VerenaProof {
  token: string;
  expiresAt: number;
}

export interface VerenaStatus {
  verified: boolean;
  expiresAt?: number;
}

let config: VerenaConfig | null = null;

export function setConfig(c: VerenaConfig): void {
  if (!c.siteKey) {
    throw new Error('Verena: siteKey is required');
  }
  config = {
    apiUrl: 'https://proof-of-person.fly.dev/',
    theme: 'light',
    ...c,
  };
  // Normalize empty apiUrl to current origin
  if (!config.apiUrl) {
    config.apiUrl = window.location.origin + '/';
  }
  // Ensure trailing slash
  if (!config.apiUrl.endsWith('/')) {
    config.apiUrl += '/';
  }
}

export function getConfig(): VerenaConfig {
  if (!config) {
    throw new Error('Verena: not initialized. Call Verena.init() first.');
  }
  return config;
}

export function isInitialized(): boolean {
  return config !== null;
}
